var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1.24988L2.83 1.60988L3.793 13.0829C3.87 14.0199 4.653 14.7389 5.593 14.7359H16.502C17.399 14.7379 18.16 14.0779 18.287 13.1899L19.236 6.63188C19.342 5.89888 18.833 5.21888 18.101 5.11288C18.037 5.10388 3.164 5.09888 3.164 5.09888",
    stroke: "#130F26",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 8.7948H14.898",
    stroke: "#130F26",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15435 18.2025C5.45535 18.2025 5.69835 18.4465 5.69835 18.7465C5.69835 19.0475 5.45535 19.2915 5.15435 19.2915C4.85335 19.2915 4.61035 19.0475 4.61035 18.7465C4.61035 18.4465 4.85335 18.2025 5.15435 18.2025Z",
    fill: "#130F26",
    fillOpacity: 0.4,
    stroke: "#130F26",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4346 18.2025C16.7356 18.2025 16.9796 18.4465 16.9796 18.7465C16.9796 19.0475 16.7356 19.2915 16.4346 19.2915C16.1336 19.2915 15.8906 19.0475 15.8906 18.7465C15.8906 18.4465 16.1336 18.2025 16.4346 18.2025Z",
    fill: "#130F26",
    fillOpacity: 0.4,
    stroke: "#130F26",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.1da21b4112c8deeee91bf4dee3acbdff.svg";
export { ForwardRef as ReactComponent };